const health3Items = document.querySelectorAll('.health-3 .health-3-content .health-3-item');
    
health3Items.forEach((item) => {
  item.addEventListener('mouseenter', () => {
    // 移除其他卡片的active类，只保留当前卡片
    document.querySelectorAll('.health-3 .health-3-content .health-3-item').forEach((i) => i.classList.remove('active'));
    // 为当前卡片添加active类
    item.classList.add('active');
  });
});
